import * as Yup from 'yup';

export const FormSchema = Yup.object().shape({
  search: Yup.string()
    .min(11, 'Minimální hodnota znaků je 11')
    .required('VIN je povinný atribut'),
});
